module.exports = __webpack_public_path__ + "static/onboarding-61c143eb06fd205425ce7520c54f9c10.png";